const SUPPORTED = [
    'json',
    'xml',
    'yaml',
    'csv',
    'toml',
    'tsv',
    'ini',
    'properties',
    'hcl',
    'ndjson',
    'env',
    'querystring'
];

export default SUPPORTED;